import React from "react";

export default function LockedAttendanceDateWarningModal({
  open,
  lockedMonths = [],
  darkMode = false,
  onDismiss,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10050]">
      <div
        className={`rounded-lg p-6 max-w-lg mx-4 shadow-lg ${
          darkMode ? "bg-gray-800 text-white" : "bg-white text-gray-900"
        }`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="locked-attendance-date-warning-title"
      >
        <div className="mb-4">
          <h3
            id="locked-attendance-date-warning-title"
            className="text-lg font-semibold text-amber-600 mb-2"
          >
            Unlock attendance first
          </h3>
          <p className="text-sm leading-relaxed">
            Changing Date of Join or Relieving Date would affect attendance in
            month(s) that are{" "}
            <span className="font-semibold">already locked</span>:{" "}
            {lockedMonths.length > 0
              ? lockedMonths.map((m) => m.label).join(", ")
              : "selected period"}
            . You cannot save this change until those month(s) are{" "}
            <span className="font-semibold">unlocked</span> from the Attendance
            screen. Revert the dates here or unlock attendance, then try again.
          </p>
        </div>
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onDismiss}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
